/* AST Protocol direction: the progress rule under phone product carousels (the gift guide's product rows,
   "Pairs with" and "More designs" on product pages).
   A 2px hairline with an ink segment sized 1/n that follows the scroll, and a Barlow "1 / n" readout.
   Styles in ast-protocol.css (.ast-slider-progress). Nothing here changes layout on desktop. */
(function () {
  var mq = window.matchMedia('(max-width: 768.98px)');
  function setUp(slider) {
    if (slider.dataset.astProgress) return;
    var items = slider.querySelectorAll('.slider__item');
    var n = items.length;
    if (n < 2) return;
    slider.dataset.astProgress = '1';
    var bar = document.createElement('div');
    bar.className = 'ast-slider-progress';
    bar.setAttribute('aria-hidden', 'true');
    bar.hidden = true; /* shown by the first update(), which runs in the next frame */
    bar.innerHTML = '<span class="ast-slider-progress__track"><b class="ast-slider-progress__thumb"></b></span><span class="ast-slider-progress__count">1 / ' + n + '</span>';
    /* After the slider's wrapper, not the slider: the theme's carousel turns that wrapper into an OverlayScrollbars
       host (display: flex, one row), which stood the rule beside the cards as a 74px column at 390px */
    slider.parentElement.insertAdjacentElement('afterend', bar);
    var thumb = bar.querySelector('.ast-slider-progress__thumb');
    var count = bar.querySelector('.ast-slider-progress__count');
    var ticking = false;
    /* AST speed (Oct 18 2026): read, then write. update() wrote the thumb's width and then read the layout, and it ran
       for each row in turn at DOMContentLoaded, so the page was laid out again for every row (about 460ms on a
       slowed phone on the sticker page). The first run now goes with the other rows' in one frame: all reads, then
       all writes. */
    function measure() {
      var max = slider.scrollWidth - slider.clientWidth;
      var grid = slider.querySelector('.slider__grid');
      var gap = grid ? parseFloat(getComputedStyle(grid).columnGap) || 0 : 0;
      return { max: max, left: slider.scrollLeft, step: items[0].getBoundingClientRect().width + gap };
    }
    function apply(m) {
      var w = 100 / n;
      var p = m.max > 0 ? Math.min(1, Math.max(0, m.left / m.max)) : 0;
      thumb.style.width = w + '%';
      thumb.style.left = (p * (100 - w)) + '%';
      var i = m.step > 0 ? Math.min(n, Math.round(m.left / m.step) + 1) : 1;
      if (m.max > 0 && m.left >= m.max - 2) i = n;
      count.textContent = i + ' / ' + n;
      bar.hidden = !(mq.matches && m.max > 2);
    }
    function update() {
      ticking = false;
      apply(measure());
    }
    slider.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('resize', update);
    firstRuns.push({ measure: measure, apply: apply });
    if (firstRuns.length === 1) window.requestAnimationFrame(runFirst);
  }
  var firstRuns = [];
  function runFirst() {
    var runs = firstRuns; firstRuns = [];
    var ms = runs.map(function (r) { return r.measure(); });
    runs.forEach(function (r, i) { r.apply(ms[i]); });
  }
  var selector = '.cc-featured-collection carousel-slider[disable-desktop] .slider';
  function init() {
    document.querySelectorAll(selector).forEach(setUp);
  }
  /* "Pairs with" arrives after load: assets/main.js fills <product-recommendations> from the recommendations route */
  function watch() {
    document.querySelectorAll('.cc-featured-collection product-recommendations').forEach(function (el) {
      if (el.dataset.astWatch) return;
      el.dataset.astWatch = '1';
      new MutationObserver(init).observe(el, { childList: true });
    });
  }
  function start() { init(); watch(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();

/* Product page: the "What you get" list under the photos (snippets/ast-pdp-features.liquid) shows on desktops 990px
   and wider. The photo and the list hold still together only when both fit in the window under the full-height
   header with 24px above and below: this adds .ast-wyg-fits to the .ast-media-stick wrapper. Without the class (or
   without JS) the media column scrolls with the page, so the list is always reachable. Styles in ast-protocol.css. */
(function () {
  var mq = window.matchMedia('(min-width: 990px)');
  var headerMax = 0; /* store-header folds from about 155px to 113px on scroll; keep the full height so the answer holds */
  function check(stick) {
    var list = stick.querySelector('.ast-wyg');
    if (!list) return;
    var header = document.querySelector('store-header');
    if (header) headerMax = Math.max(headerMax, header.offsetHeight);
    var css = getComputedStyle(list);
    var gap = parseFloat(css.marginTop) || 0;
    /* the photo block is the wrapper minus the list, whether the list is in the flow (showing) or lifted out (hidden) */
    var photo = stick.offsetHeight - (css.position === 'static' ? list.offsetHeight + gap : 0);
    var need = headerMax + 24 + photo + gap + list.offsetHeight + 24;
    stick.classList.toggle('ast-wyg-fits', mq.matches && need <= window.innerHeight);
  }
  function init() {
    document.querySelectorAll('.ast-media-stick').forEach(function (stick) {
      if (stick.dataset.astWyg) return;
      stick.dataset.astWyg = '1';
      var run = function () { check(stick); };
      if ('ResizeObserver' in window) new ResizeObserver(run).observe(stick);
      window.addEventListener('resize', run);
      run();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* Homepage reviews carousel (Okendo): a review title that only repeats the rating ("5 Stars", what Okendo shows when a
   reviewer leaves the title empty) gets .ast-oke-rating-title and is hidden, since the stars sit right above it. Okendo
   draws the carousel in the browser, so this watches the app block that holds it. Real titles are untouched.
   Styles in ast-protocol.css. */
(function () {
  var RATING_ONLY = /^\s*[1-5](\.0)?\s+stars?\s*$/i;
  function mark(root) {
    root.querySelectorAll('.oke-reviewCarousel .oke-reviewContent-title:not(.ast-oke-rating-title)').forEach(function (t) {
      if (RATING_ONLY.test(t.textContent)) t.classList.add('ast-oke-rating-title');
    });
  }
  function watch(holder) {
    if (holder.dataset.astOkeTitles) return;
    holder.dataset.astOkeTitles = '1';
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () { queued = false; mark(holder); });
    }).observe(holder, { childList: true, subtree: true });
    mark(holder);
  }
  function init() {
    /* the placeholder, or the carousel itself if Okendo has already drawn it in its place */
    document.querySelectorAll('[data-oke-carousel], .oke-reviewCarousel').forEach(function (el) {
      watch(el.closest('.shopify-block') || el.parentNode || el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* Product page star row (snippets/ast-pdp-stars.liquid): the row links to the reviews heading (#reviews); this turns
   the jump into a smooth scroll (an instant one with reduced motion). Where that heading is not on the page (the
   quick-add drawer on a collection page), the row opens the product page at its reviews instead. */
(function () {
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a.ast-pdp-rating') : null;
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var target = document.getElementById('reviews');
    var url = a.getAttribute('data-url');
    if (target) {
      e.preventDefault();
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    } else if (url && new URL(url, location.href).pathname !== location.pathname) {
      e.preventDefault();
      location.href = url + '#reviews';
    }
  });
})();

/* Menu links to a spot on the page the shopper is already on, like the Guides menu's "Free goals tracker"
   (/#goals-tracker) on the homepage: close the phone menu so the shopper sees the page move to the signup. Without
   this the page scrolled behind the open menu and nothing seemed to happen (audit F14, October 2026). */
(function () {
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('main-menu a[href*="#"]') : null;
    if (!a || e.defaultPrevented) return;
    var u = new URL(a.href, location.href);
    if (!u.hash || u.pathname !== location.pathname) return;
    var menu = a.closest('main-menu');
    if (menu && typeof menu.closeMainDisclosure === 'function') menu.closeMainDisclosure();
  });
})();

/* Cart free-shipping moment (snippets/cart-tiered-progress.liquid; the CSS is "Free US shipping reached" in
   ast-protocol.css). The CSS plays the gradient fill, the check and the pink mark whenever a reached panel shows. This
   keeps it to once per crossing: when the play ends, a session flag is set and the panel gets .is-settled, and every
   later copy of the panel (a drawer or cart refresh, the drawer opening again, the next page) is settled as soon as
   it is inserted, before it paints. The flag clears when the cart drops under the line or empties, so the next
   crossing plays again. The fill starts from where the bar was before the crossing. If storage is blocked the moment
   simply plays each time the panel shows. */
(function () {
  var KEY = 'ast-ship-won';
  var from = 0;
  function played() {
    try { return window.sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; }
  }
  function mark(on) {
    try {
      if (on) window.sessionStorage.setItem(KEY, '1');
      else window.sessionStorage.removeItem(KEY);
    } catch (e) { /* storage blocked: nothing to remember */ }
  }
  function scan() {
    var panels = document.querySelectorAll('.cart-tiered-progress');
    var won = [];
    for (var i = 0; i < panels.length; i++) {
      if (panels[i].classList.contains('cart-tiered-progress--won')) {
        won.push(panels[i]);
      } else {
        var fill = panels[i].querySelector('.cart-tiered-progress__fill');
        var pct = fill ? parseFloat(fill.style.width) : NaN;
        if (!isNaN(pct)) from = Math.max(0, Math.min(pct, 100)) / 100;
      }
    }
    if (!panels.length) from = 0;
    if (!won.length) { mark(false); return; }
    var done = played();
    for (var j = 0; j < won.length; j++) {
      if (done) won[j].classList.add('is-settled');
      else if (!won[j].style.getPropertyValue('--ast-fill-from')) won[j].style.setProperty('--ast-fill-from', String(from));
    }
  }
  document.addEventListener('animationend', function (e) {
    if (e.animationName !== 'ast-ship-mark' || !e.target.closest) return;
    var panel = e.target.closest('.cart-tiered-progress--won');
    if (!panel) return;
    mark(true);
    panel.classList.add('is-settled');
  });
  scan();
  if (!window.MutationObserver) return;
  var mo = new MutationObserver(scan);
  ['cart-drawer', 'cart'].forEach(function (id) {
    var root = document.getElementById(id);
    if (root) mo.observe(root, { childList: true, subtree: true });
  });
})();


/* AST-A11Y (WCAG 2.2 AA pass, Oct 13 2026; docs/ast/accessibility-2026-10-13.md) */
(function () {
  /* 1. The words inside a menu toggle are no longer a second link inside the toggle (sections/header.liquid keeps the
     address in data-href; the panel repeats the link for keyboards and screen readers). A mouse click on the words
     still opens the page, as before; a tap on a touch screen still opens the menu (the theme's own handler). */
  function hrefOf(e) {
    var a = e.target && e.target.closest && e.target.closest('summary a[data-href]');
    if (!a || getComputedStyle(a).pointerEvents === 'none') return null;
    if (e.pointerType === 'touch' || (window.theme && theme.device && theme.device.hasHover === false)) return null;
    return a.getAttribute('data-href');
  }
  document.addEventListener('click', function (e) {
    if (e.detail === 0) return; /* Enter or Space on the toggle: it stays a toggle */
    var url = hrefOf(e); if (!url) return;
    e.preventDefault(); e.stopPropagation();
    if (e.metaKey || e.ctrlKey || e.shiftKey) window.open(url, '_blank'); else window.location.href = url;
  }, true);
  document.addEventListener('auxclick', function (e) {
    if (e.button !== 1) return; var url = hrefOf(e); if (!url) return;
    e.preventDefault(); window.open(url, '_blank');
  }, true);

  /* 2. A box that scrolls sideways with nothing focusable inside (a wide table, the photo strip on phones) takes
     keyboard focus, so it can be scrolled with the arrow keys, and is named by its section's heading. */
  var TABBABLE = 'a[href], button, input, select, textarea, summary, [tabindex]:not([tabindex="-1"])';
  function regions() {
    /* AST speed (Oct 18 2026): find every box first, then mark them. Marking one (attributes) and then reading the
       next box's style made the browser restyle the page once per box found. */
    var els = document.querySelectorAll('main div, main ul, main table');
    var found = [];
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.hasAttribute('data-ast-scroll') || el.closest('[class*="oke-"], .okeReviews')) continue;
      var ox = getComputedStyle(el).overflowX;
      if ((ox !== 'auto' && ox !== 'scroll') || el.scrollWidth <= el.clientWidth + 2) continue;
      if (el.querySelector(TABBABLE)) continue;
      found.push(el);
    }
    for (var j = 0; j < found.length; j++) {
      el = found[j];
      el.setAttribute('data-ast-scroll', '');
      el.setAttribute('tabindex', '0');
      if (!el.getAttribute('role')) el.setAttribute('role', 'region');
      if (!el.getAttribute('aria-label') && !el.getAttribute('aria-labelledby')) {
        var cap = el.querySelector('caption'), sec = el.closest('.shopify-section, section, article');
        var h = cap || (sec && sec.querySelector('h1, h2, h3'));
        el.setAttribute('aria-label', (h && h.textContent.replace(/\s+/g, ' ').trim()) || 'Scrolling content');
      }
    }
  }
  /* 3. Escape closes the phone menu and puts focus back on its toggle, as it does for the cart drawer */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || e.astMenuHandled || window.matchMedia('(min-width: 769px)').matches) return;
    var d = document.querySelector('main-menu .main-menu__disclosure'), tog = d && d.querySelector('.main-menu__toggle');
    if (!d || !d.open || !tog || !d.contains(document.activeElement)) return;
    if (d.querySelector('.main-nav details.is-open')) return; /* an open sub-menu: the theme's own Escape steps back first */
    tog.click(); tog.focus();
  });

  var t = null;
  function later() { clearTimeout(t); t = setTimeout(regions, 400); }
  if (document.readyState === 'complete') later(); else window.addEventListener('load', later);
  window.addEventListener('resize', later);
})();
/* AST-A11Y-END */

/* Sources accordion (Erika, Oct 13 2026: "make sources on blogs smaller text and an accordion defaulted to closed").
   Every article and guide body ends with an H2 "Sources" and its list (docs/ast/blog/FORMATTING-STANDARD.md rule 6).
   This moves that H2 and everything after it in the same parent into <details class="ast-sources">, closed: the H2
   itself goes inside the <summary>, so it keeps its id (the "In this guide" links to #sources still land on it) and
   its heading role. A link to the heading or to anything inside opens the box first: on load, on hashchange and on
   click. The chevron is Hugeicons' ArrowDown01Icon, the glyph snippets/ast-icon.liquid draws for keyboard_arrow_down
   (@hugeicons/core-free-icons 4.3.5, MIT, notice in that snippet; since Oct 23 2026). Styles are in assets/article.css ("Sources accordion"). A page with
   no such H2 is left alone, and without this script the list shows open as before. */
(function () {
  var CHEVRON = 'M18 9.00005C18 9.00005 13.5811 15 12 15C10.4188 15 6 9 6 9';
  var STOP = 'h2, .ast-inline-promo, .faq-container, .cta-banner';
  function build() {
    var seen = [];
    document.querySelectorAll('.article-content h2').forEach(function (h) {
      if (seen.indexOf(h) === -1) seen.push(h);
    });
    var target = null;
    seen.forEach(function (h) {
      if (/^sources$/i.test((h.textContent || '').trim()) && !h.closest('details, .faq-container')) target = h;
    });
    if (!target || !target.parentNode) return;
    var parent = target.parentNode;
    var details = document.createElement('details');
    details.className = 'ast-sources';
    var summary = document.createElement('summary');
    summary.className = 'ast-sources__summary';
    var body = document.createElement('div');
    body.className = 'ast-sources__body';
    var next = target.nextElementSibling;
    var move = [];
    while (next && !next.matches(STOP)) { move.push(next); next = next.nextElementSibling; }
    parent.insertBefore(details, target);
    summary.appendChild(target);
    summary.insertAdjacentHTML('beforeend', '<svg class="ast-icon ast-sources__chevron" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" focusable="false" aria-hidden="true"><path d="' + CHEVRON + '"/></svg>');
    move.forEach(function (el) { body.appendChild(el); });
    details.appendChild(summary);
    details.appendChild(body);
  }
  function openFor(hash, scroll) {
    if (!hash || hash.length < 2) return false;
    var id = hash.slice(1);
    try { id = decodeURIComponent(id); } catch (e) { /* keep the raw id */ }
    var el = document.getElementById(id);
    var box = el && el.closest('details.ast-sources');
    if (!box) return false;
    /* land below the sticky header, which otherwise covers the heading */
    el.style.scrollMarginTop = headerOffset() + 'px';
    if (box.open) return false;
    box.open = true;
    if (scroll) {
      var reduce = scroll === 'instant' || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }
    return el;
  }
  function headerOffset() {
    var h = document.querySelector('.shopify-section.cc-header') || document.getElementById('shopify-section-header');
    var pos = h ? getComputedStyle(h).position : '';
    return (pos === 'sticky' || pos === 'fixed' ? h.offsetHeight : 0) + 16;
  }
  function init() {
    try { build(); } catch (e) { return; }
    if (!document.querySelector('details.ast-sources')) return;
    /* a page opened at #sources: open it at once, and place the heading again once the photos above have loaded */
    var landed = openFor(location.hash, 'instant');
    if (landed) window.addEventListener('load', function () {
      if (window.scrollY <= 0) return;
      landed.style.scrollMarginTop = headerOffset() + 'px';  /* the header turns sticky only once main.js has run */
      landed.scrollIntoView({ behavior: 'auto', block: 'start' });
    });
    window.addEventListener('hashchange', function () { openFor(location.hash, true); });
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href*="#"]') : null;
      if (!a) return;
      var u = new URL(a.href, location.href);
      if (u.pathname === location.pathname) openFor(u.hash, false);
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Listicle item numbers (Erika, Oct 14 2026, "a tad of excitement", picked C). A heading in an article or page body
   (.article-content h2, h3) whose text starts "N. " gets an oversized hollow numeral: the digit drawn as an outline
   only, stroked with the shared #astGradState gradient in layout/theme.liquid (violet #5B5BE1 to deep pink #D52695;
   solid violet if the gradient is missing), no fill. The "N. " stays in the heading as visually hidden text, so screen
   readers and copying read "1. ..." as before; the drawn numeral is aria-hidden and can't be selected. The heading gets
   .ast-numbered, and assets/article.css ("Listicle item numbers") hangs the numeral in a 104px left gutter from 990px
   up and stacks it above the heading below that. Headings inside the FAQ cards, the "In this guide" list, callouts
   and the Sources accordion are left alone. Without this script the headings read "1. ..." as before. */
(function () {
  var NS = 'http://www.w3.org/2000/svg';
  var RE = /^\s*(\d{1,2})\.\s+/;
  function init() {
    var heads = document.querySelectorAll('.article-content h2, .article-content h3');
    for (var i = 0; i < heads.length; i++) {
      var h = heads[i];
      if (h.classList.contains('ast-numbered') || h.closest('details, .toc, .callout, .faq-container, .ast-faq')) continue;
      var t = h.firstChild;
      while (t && t.nodeType === 3 && !/\S/.test(t.nodeValue)) t = t.nextSibling;
      if (!t || t.nodeType !== 3) continue;
      var m = t.nodeValue.match(RE);
      if (!m) continue;
      var n = m[1];
      t.nodeValue = t.nodeValue.slice(m[0].length);
      var sr = document.createElement('span');
      sr.className = 'ast-num-sr';
      sr.textContent = n + '. ';
      var svg = document.createElementNS(NS, 'svg');
      svg.setAttribute('class', 'ast-num');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      var tx = document.createElementNS(NS, 'text');
      tx.setAttribute('x', '0');
      tx.setAttribute('y', '.72em');
      tx.setAttribute('fill', 'none');
      tx.setAttribute('stroke', 'url(#astGradState) #5B5BE1');
      tx.setAttribute('stroke-width', '1.75');
      tx.textContent = n;
      svg.appendChild(tx);
      h.insertBefore(sr, t);
      h.insertBefore(svg, sr);
      h.classList.add('ast-numbered');
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Bundle builder "Add pack to cart" (Section Store's ss-bundle-builder sections, a plain form post to /cart/add that
   goes on to the cart page): the label says "Adding…" from the tap until the cart page loads, the button is aria-busy
   and a second tap doesn't post the pack twice. The phone sticky bar's "Add pack" says the same. Coming back with the
   browser's Back button puts the labels back (Erika, Oct 15 2026: "the button goes all white after you click it and
   its confusing"). */
(function () {
  if (window.astBundleBusyBound) return;
  window.astBundleBusyBound = true;
  var busy = [];
  function textNode(btn) {
    for (var n = btn.firstChild; n; n = n.nextSibling) if (n.nodeType === 3 && n.nodeValue.trim()) return n;
    return null;
  }
  function set(btn) {
    var t = textNode(btn);
    if (!t) return;
    busy.push({ btn: btn, node: t, text: t.nodeValue });
    btn.style.minWidth = btn.offsetWidth + 'px';
    t.nodeValue = 'Adding…';
    btn.setAttribute('aria-busy', 'true');
    btn.setAttribute('data-ast-state', 'adding');
  }
  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form || !form.matches || !form.matches('form[class^="bundle-form-template"]')) return;
    var btn = form.querySelector('[class^="bundle-submit-button-template"], [class^="bundle-button-template"]');
    if (!btn) return;
    if (btn.getAttribute('aria-busy') === 'true') { evt.preventDefault(); return; }
    if (evt.defaultPrevented) return;
    set(btn);
    var bar = document.querySelector('[data-ast-bb-add]');
    if (bar) set(bar);
  });
  window.addEventListener('pageshow', function () {
    busy.forEach(function (b) {
      b.node.nodeValue = b.text;
      b.btn.removeAttribute('aria-busy');
      b.btn.removeAttribute('data-ast-state');
      b.btn.style.minWidth = '';
    });
    busy = [];
  });
})();

/* ---------- SIGN-UP FORMS: never a frozen button (Oct 26 2026) ----------
   The three native sign-up forms (the goals pop-up, the email bands, the guide sign-up card) carry data-ast-signup.
   Shopify's spam check cancels a submit made before it has finished loading and never sends it again, and an ad or
   privacy blocker can stop it loading at all, so a press can go nowhere with nothing on screen (diagnosis:
   docs/ast/store/signup-forms-2026-10-26.md on ast-docs). When the page has not moved on about 8 seconds after a
   press, the button is put back and the form's line (snippets/ast-signup-retry.liquid) says to try again. While
   hCaptcha's picture puzzle is on screen the visitor is still mid sign-up, so the 8 seconds start once it closes.
   The form gets an "ast:signup-retry" event so its own busy state (the pop-up's label and spinner) can reset too.
   Capture phase, so it starts whatever another listener on the form does with the event. */
(function () {
  var WAIT = 8000;
  var timers = [];
  var puzzleOpen = function () {
    var frames = document.querySelectorAll('iframe[src*="hcaptcha"]');
    for (var i = 0; i < frames.length; i++) {
      var f = frames[i];
      var r = f.getBoundingClientRect();
      if (r.width < 50 || r.height < 50) continue;
      if (typeof f.checkVisibility === 'function') {
        if (f.checkVisibility({ opacityProperty: true, visibilityProperty: true })) return true;
      } else if (f.offsetParent !== null) {
        return true;
      }
    }
    return false;
  };
  var reset = function (form) {
    var buttons = form.querySelectorAll('button[type="submit"], [data-ast-newsletter-btn]');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].disabled = false;
      buttons[i].removeAttribute('aria-busy');
      buttons[i].classList.remove('is-loading');
    }
    var line = form.querySelector('[data-ast-signup-retry]');
    if (line) line.textContent = line.getAttribute('data-text') || '';
    var ev;
    try { ev = new CustomEvent('ast:signup-retry'); } catch (e) { ev = document.createEvent('Event'); ev.initEvent('ast:signup-retry', false, false); }
    form.dispatchEvent(ev);
  };
  var watch = function (form) {
    var since = Date.now();
    var id = setInterval(function () {
      if (puzzleOpen()) { since = Date.now(); return; }
      if (Date.now() - since < WAIT) return;
      clearInterval(id);
      reset(form);
    }, 500);
    timers.push(id);
    return id;
  };
  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form || !form.matches || !form.matches('form[data-ast-signup]')) return;
    var line = form.querySelector('[data-ast-signup-retry]');
    if (line) line.textContent = '';
    /* a tag that is new on every submit (snippets/ast-signup-form.liquid): tracker-YYYY-MM-DD-HHMM in UTC, written
       now because the page's own value may come from Shopify's cache */
    var tagInput = form.querySelector('input[data-ast-signup-tags]');
    if (tagInput) {
      var d = new Date();
      var p2 = function (n) { return (n < 10 ? '0' : '') + n; };
      var stamp = 'tracker-' + d.getUTCFullYear() + '-' + p2(d.getUTCMonth() + 1) + '-' + p2(d.getUTCDate()) + '-' + p2(d.getUTCHours()) + p2(d.getUTCMinutes());
      var base = tagInput.getAttribute('data-ast-signup-tags') || '';
      tagInput.value = base ? base + ', ' + stamp : stamp;
    }
    if (form._astSignupWatch) clearInterval(form._astSignupWatch);
    form._astSignupWatch = watch(form);
  }, true);
  /* a page restored from the back-forward cache comes back with the button as it was left */
  window.addEventListener('pageshow', function (evt) {
    if (!evt.persisted) return;
    timers.forEach(clearInterval);
    timers = [];
    var forms = document.querySelectorAll('form[data-ast-signup]');
    for (var i = 0; i < forms.length; i++) {
      var buttons = forms[i].querySelectorAll('button[type="submit"], [data-ast-newsletter-btn]');
      for (var j = 0; j < buttons.length; j++) { buttons[j].disabled = false; buttons[j].removeAttribute('aria-busy'); buttons[j].classList.remove('is-loading'); }
    }
  });
})();
